import { Component, EventEmitter, Inject, Input, LOCALE_ID, Output } from '@angular/core';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CustomMessagesService } from '../../services/custom-messages.service';
import { locales } from 'src/app/resources/locales';
import { User } from 'src/app/global-functions';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header-component',
    templateUrl: './header.commponent.html'
})
export class HeaderComponent {
    @Output() public toggle = new EventEmitter();
    @Input() public selectedPage?: string;

    public customMsgService: CustomMessagesService;
    public userName: string = '';
    public userType: string = '';
    public selectedLanguage = { locale: 'Portugal', localeId: 'pt' };
    public locales = locales;
    public popupSettings = { width: '150' };
    public themes: { href: string, text: string }[] = [
        {
            href: 'assets/kendo-theme-default/dist/all.css',
            text: 'Bootstrap'
        }, {
            href: 'assets/kendo-theme-default/dist/default-ocean-blue.css',
            text: 'Default'
        }, {
            href: 'assets/kendo-theme-material/dist/all.css',
            text: 'Material'
        }
    ];
    public selectedTheme = this.themes[0];

    constructor(public messages: MessageService, @Inject(LOCALE_ID) public localeId: string, public intlService: IntlService, private router: Router, private auth: AuthService) {
        var user = User.userInSession();
        this.localeId = user.LocateID;
        this.setLocale(this.localeId);
        this.items.push({
            icon: 'user',
            items: [{ text: user.Email + ' | ' + user.Funcao, disabled: true }, { icon: 'edit', text: 'Alterar password', url: '#/changepass' }, { icon: 'logout', text: 'Terminar sessão', click: () => this.logOut() }]
        })
        this.userName = user.Email;
        this.userType = user.Funcao;
        this.customMsgService = this.messages as CustomMessagesService;
        this.customMsgService.language = this.localeId;
    }

    public changeTheme(theme: { href: string, text: string }) {
        this.selectedTheme = theme;
        const themeEl: any = document.getElementById('theme');
        themeEl.href = theme.href;
    }

    public changeLanguage(item: any): void {
        this.customMsgService.language = item.localeId;
        this.setLocale(item.localeId);
    }

    public setLocale(locale: any): void {
        (this.intlService as CldrIntlService).localeId = locale;
    }

    public onButtonClick(): void {
        this.toggle.emit();
    }

    public logOut(): void {
        this.auth.logout();
        this.router.navigateByUrl('login');

    }

    public onclick(): void {
        var user = User.userInSession();
        var idSolucao = user.IDSolucaoEntidade;
        var idFuncao = user.IDFuncao;
        if (idFuncao == 0) {
            this.router.navigate(['dashboardtm']);
        } else {
            if (idSolucao == 2) {
                this.router.navigate(['dashboardtm']);
            } else if (idSolucao == 1) {
                this.router.navigate(['dashboardiv']);
            } else if (idSolucao == 3) {
                this.router.navigate(['dashboardivtm']);
            }
        }
    }

    public items: any[] = new Array<any>();
}